// src/appConfig.js - NUOVO FILE
// Questo file è la singola fonte di verità per le pagine dell'applicazione.

// 1. Definiamo la struttura della navigazione
export const navStructure = [
    {
        type: 'link',
        label: 'Turni',
        path: '/turni',
        key: 'shifts',
    },
    {
        type: 'link',
        label: 'Documenti',
        path: '/procedure',
        key: 'procedures',
    },
    /*{ // NUOVA VOCE PER IL CALENDARIO
        type: 'link',
        label: 'Calendario',
        path: '/calendario',
        key: 'calendar', // Chiave per i permessi
    },*/
    
    {
        type: 'link',
        label: 'Stanze',
        path: '/stanze',
        key: 'rooms',
    },
    {
                type: 'link',
                label: 'Timbrature',
                path: '/timbrature',
                key: 'timelogs',
            },
            {
                type: 'link',
                label: 'Assenze',
                path: '/assenze',
                key: 'leaves',
            },
            // --- INIZIO NUOVA VOCE MENU MEDICI ---
            {
                type: 'link',
                label: 'I Miei Compensi',
                path: '/miei-compensi',
                key: 'myCompensations', // 🎯 FIX: Chiave univoca per non confonderla con le paghe dell'admin
            },
            // --- FINE NUOVA VOCE ---
   {
        type: 'dropdown',
        label: 'Gestione ▾', // Etichetta per il pulsante del dropdown
        key: 'gestione_dropdown', // Chiave unica per il dropdown
        subItems: [
            
            {
                type: 'link',
                label: 'Paghe',
                path: '/paghe',
                key: 'payroll',
            },
            {
                type: 'link',
                label: 'Buste Paga',
                path: '/buste-paga',
                key: 'payslips',
            },
            {
                type: 'link',
                label: 'Note Spesa', // NUOVA VOCE
                path: '/note-spesa', // NUOVA ROTTA
                key: 'expenseNotes', // NUOVA CHIAVE PERMESSI
            },
            {
                type: 'link',
                label: 'Reportistica', // NUOVA VOCE
                path: '/reports',
                key: 'reports', // Richiede permesso specifico (es. Manager)
            },
            {
                type: 'link',
                label: 'Gestione Personale',
                path: '/personale',
                key: 'staff',
            },
            // --- INIZIO MODIFICA ---
            {
                type: 'link',
                label: 'Impostazioni Turni',
                path: '/calcolo-turni', // NUOVA ROTTA
                key: 'shiftRules', // NUOVA CHIAVE (usiamo 'shifts' per i permessi?)
            },
            {
                type: 'link',
                label: 'Gestione Centro',
                path: '/gestione-centro',
                key: 'centerManagement', // La chiave per i permessi
            },
            {
                type: 'link',
                label: 'Log Attività', // Ho aggiunto l'icona nel testo per visibilità
                path: '/logs',
                key: 'logs', // Usa questa chiave per ereditare i permessi di gestione centro
            },
            {
                type: 'link',
                label: '👑 Pannello MIA',
                path: '/admin',
                key: 'adminDashboard',
            },
        ]
    }
    // --- FINE BLOCCO DROPDOWN ---
];

// 2. Funzione modificata per includere permessi "nascosti"
export const getPermissionablePages = () => {
    const pages = [];
    
    // 1. Aggiungi le pagine presenti nel menu.
    // Le chiavi in EXCLUDED_FROM_PERMISSIONS non appaiono nella griglia permessi dello StaffModal:
    // - 'myCompensations': attiva di default solo per i medici, non configurabile manualmente
    // - 'adminDashboard': pannello super admin, non delegabile allo staff
    const EXCLUDED_FROM_PERMISSIONS = ['myCompensations', 'adminDashboard'];

    navStructure.forEach(item => {
        if (item.type === 'link') {
            if (!EXCLUDED_FROM_PERMISSIONS.includes(item.key)) {
                pages.push({ key: item.key, label: item.label });
            }
        } else if (item.type === 'dropdown') {
            item.subItems.forEach(sub => {
                // Evita duplicati se usiamo la stessa chiave più volte (es. 'shifts')
                if (!pages.some(p => p.key === sub.key) && !EXCLUDED_FROM_PERMISSIONS.includes(sub.key)) {
                    pages.push({ key: sub.key, label: sub.label });
                }
            });
        }
    });

    // 2. --- AGGIUNTA MANUALE ---
    // Inserisci qui le pagine che non sono nel menu ma richiedono permessi
    pages.push({ key: 'announcements', label: 'Bacheca' });
    // ---------------------------

    return pages;
};